import logo from './logo.svg';
import './App.css';
import * as React from "react";
import {  BrowserRouter as Router, Route, Routes  } from "react-router-dom";
import Home from './components/Home/Home';
import About from './components/About/About';
import AllProjects from './components/AllProjects/AllProjects';
import Header from './components/Header/Header';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import MyService from './MyService/MyService';
import Blogs from './components/Blogs/Blogs';

function App() {
  return (
    <div className="App">
     <Router>
      <Header></Header>
       <Routes>
       <Route path="/" element={<Home />} />
       <Route path="/home" element={<Home />} />
       <Route path="/about" element={<About />} />
       <Route path="/contact" element={<Contact />} />
       <Route path="/allprojects" element={<AllProjects />} />
       <Route path="/myservice" element={<MyService />} />
       <Route path="/blog" element={<Blogs />} />
       <Route path="/footer" element={<Footer />} />
       </Routes>
     </Router>
    </div>
  );
}

export default App;
